import { BasicService } from './core/basic.service'

export class CategoriesService extends BasicService {

  static async save(data) {
    await this.extractImg(data, 'image')
    return this.http.post('/goods/categorySave', data);
  }

  static delete(id) {
    return this.http.post('/goods/delCategory', { id });
  }
}